import { logAmplitudeEvent } from 'amplitude/amplitude'
import { authSelectors } from 'ducks/auth'
import { updateSelectedHardwareSupplier } from 'ducks/orderComponents'
import { orgsActions } from 'ducks/orgs'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { claimSupplierReferralUrlFragment } from 'supplierReferral/referralFragmentPath'
import restClient from 'restClient'

/**
 * Handles supplier referral connection for the **registration** flow.
 * Login flow is handled in authSaga (USER_LOGIN_SUCCESS) where the connect
 * runs before reloadOrg() to avoid a race with GET_ORG reading stale preferences.
 */
export const useSupplierReferralLink = () => {
  const isAuthenticatedPro = useSelector(authSelectors.getIsAuthenticatedPro)
  const orgId = useSelector(authSelectors.getOrgId)
  const user = useSelector(authSelectors.getCurrentUser)
  const proEmail = user?.email || ''
  const dispatch = useDispatch()

  useEffect(() => {
    if (!isAuthenticatedPro || !orgId) {
      return
    }

    const fragment = claimSupplierReferralUrlFragment()
    if (!fragment) {
      return
    }

    const restClientInstance = restClient(window.API_ROOT + '/api')
    restClientInstance('CUSTOM_POST', 'custom', {
      url: 'supplier_referral_connect/',
      data: { url_fragment: fragment, org_id: orgId },
    })
      .then((response: any) => {
        const data = response?.data || {}
        if (data.connected === true && data.supplier_key) {
          logAmplitudeEvent('supplier_referral_link', {
            supplier_key: data.supplier_key,
            url_fragment: fragment,
            source: 'existing',
            pro_email_address: proEmail,
          })

          dispatch(updateSelectedHardwareSupplier(data.supplier_key))
          dispatch(orgsActions.setSupplierPreferences(data.supplier_preferences || []))
        }
      })
      .catch(() => {
        // Non-blocking: referral connection is best-effort (PRD).
      })
  }, [isAuthenticatedPro, orgId, proEmail])
}
